import { computed as y, openBlock as e, createElementBlock as s, normalizeClass as f, Fragment as u, renderList as h, createCommentVNode as g, toDisplayString as p, createElementVNode as D, renderSlot as H, createBlock as c, unref as k, createVNode as T, withCtx as v } from "vue";
import { themeProp as F } from "../../composables/useTheme.js";
import q from "./components/table-column.vue.js";
import j from "./components/table-row-group-header.vue.js";
import E from "./components/table-row-group.vue.js";
import N from "./components/table-row.vue.js";
import b from "../../atoms/icon-core/icon-core.vue.js";
import V from "../../atoms/divider/divider.vue.js";
const A = {
  key: 0,
  class: "ds-table-list"
}, O = ["innerHTML"], w = {
  key: 0,
  class: "ds-margin-bottom-24"
}, I = ["innerHTML"], P = ["innerHTML"], _ = ["aria-label", "aria-rowcount"], G = ["innerHTML"], J = ["innerHTML"], K = /* @__PURE__ */ Object.assign({
  name: "DsTable"
}, {
  __name: "table",
  props: {
    ...F,
    /**
     * Table title, for aria-label
     */
    title: { type: String, required: !0 },
    /**
     * Table columns, table columns data, contains table column headers
     * e.g [{ key: 'col1', text: 'Column 1', cols: '3', align: 'left' }]
     */
    columns: { type: Array, required: !0 },
    /**
     * Table rows, table rows data
     * e.g [{
     *       key: 'rowGroup1',
     *       columns: { col1: text, col2: text, col3: text, col4: text }
     *     }],
     */
    rows: { type: Array, required: !0 },
    /**
     * Screen prop, to render the table on different screens
     */
    screen: { type: String, required: !0 },
    /**
     * Text size prop, sets the font size in the table. Possible values are small, medium and large. Defaults to medium.
     */
    textSize: { type: String, default: "medium", validator: (t) => ["small", "medium", "large"].includes(t) },
    /**
     * Type prop, controls the table layout.
     */
    type: {
      type: String,
      default: "primary",
      validator: (t) => ["primary", "secondary", "tertiary"].includes(t)
    },
    /**
     * Should be first column of every row be treated as a header?
     */
    isFirstColumnHeader: {
      type: Boolean,
      default: !1
    },
    /**
     * Table loading, adds `ds-shimmer` class when loading column data
     * e.g {
     *   key: 'loadingKey',
     *   columns: { col1: true, col2: false, col3: true }
     * },
     */
    loading: {
      type: Object,
      default: () => ({ columns: {} })
    },
    /**
     * Removes the dividers between rows, asides from the first row
     */
    noDivider: {
      type: Boolean,
      default: !1
    },
    /**
     * Supports Icon support - Specifically for Terminals Comparison page
     */
    withBooleanIcon: {
      type: Boolean,
      default: !1
    },
    /**
     * Stretches the table to fit Grid - Specifically for Terminals Comparison page
     */
    isStretched: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const C = {
      primary: [
        { control: "table", screen: "large" },
        { control: "table", screen: "medium" },
        { control: "list", screen: "small" }
      ],
      secondary: [
        { control: "list", screen: "large" },
        { control: "list", screen: "medium" },
        { control: "list", screen: "small" }
      ],
      tertiary: [
        { control: "table", screen: "large" },
        { control: "table", screen: "medium" },
        { control: "table", screen: "small" }
      ]
    }, a = t, n = (i, o) => o[i] ?? "-", L = (i, o) => {
      const l = n(i, o);
      return l == null || l === "-";
    }, $ = (i) => {
      var o;
      return !!((o = a.loading) != null && o.columns[i]);
    }, B = y(() => a.isFirstColumnHeader ? [...a.columns].slice(1) : a.columns), M = y(() => a.textSize === "small" ? "ds-text-small" : "ds-text"), S = y(() => a.textSize === "small" ? "ds-table__header--small" : a.textSize === "medium" ? "ds-table__header" : "ds-heading-xsmall"), x = y(() => C[a.type].find((o) => o.screen === a.screen)), z = y(() => x.value.control === "list");
    return (i, o) => (e(), s("div", {
      class: f(M.value)
    }, [
      z.value ? (e(), s("div", A, [
        (e(!0), s(u, null, h(t.rows, (l, d) => (e(), s("div", {
          key: `row-${d}`,
          class: f(["ds-margin-top-24", { "ds-margin-bottom-24": d < t.rows.length - 1 }])
        }, [
          t.isFirstColumnHeader ? (e(), s("h2", {
            key: 0,
            class: f(["ds-text ds-margin-bottom-24", [S.value]]),
            innerHTML: l.columns.col1
          }, null, 10, O)) : g("", !0),
          (e(!0), s(u, null, h(B.value, (r, m) => (e(), s("div", {
            key: `column-${d}-${m}`
          }, [
            L(r.key, l.columns) ? g("", !0) : (e(), s("div", w, [
              r.text ? (e(), s("h3", {
                key: 0,
                class: f([S.value, { "ds-margin-bottom-8": t.textSize === "small" }])
              }, p(r.text), 3)) : g("", !0),
              D("div", null, [
                H(i.$slots, r.key, {
                  row: l,
                  item: n(r.key, l.columns)
                }, () => [
                  t.withBooleanIcon ? (e(), s(u, { key: 0 }, [
                    n(r.key, l.columns) === !0 ? (e(), c(k(b), {
                      key: 0,
                      class: "ds-color-green",
                      category: "interface",
                      name: "checkmark-circle-fill"
                    })) : n(r.key, l.columns) === !1 ? (e(), c(k(b), {
                      key: 1,
                      class: "ds-color-grey-500",
                      category: "interface",
                      name: "cross-circle-fill"
                    })) : (e(), s("div", {
                      key: 2,
                      innerHTML: n(r.key, l.columns)
                    }, null, 8, I))
                  ], 64)) : (e(), s("div", {
                    key: 1,
                    innerHTML: n(r.key, l.columns)
                  }, null, 8, P))
                ])
              ])
            ]))
          ]))), 128)),
          d < t.rows.length - 1 ? (e(), c(k(V), {
            key: 1,
            theme: i.theme
          }, null, 8, ["theme"])) : g("", !0)
        ], 2))), 128))
      ])) : (e(), s("div", {
        key: 1,
        role: "table",
        class: f(["ds-table", `ds-table--${i.theme}`]),
        "aria-label": t.title,
        "aria-rowcount": t.rows.length,
        "data-j-table": ""
      }, [
        T(j, {
          columns: t.columns,
          secondary: "",
          class: "ds-table__header"
        }, null, 8, ["columns"]),
        (e(!0), s(u, null, h(t.rows, (l, d) => (e(), c(E, {
          key: l.key,
          "no-divider": t.noDivider,
          stretch: t.isStretched
        }, {
          default: v(() => [
            T(N, {
              stretch: t.isStretched,
              "row-index": d + 1
            }, {
              default: v(() => [
                (e(!0), s(u, null, h(t.columns, (r, m) => (e(), c(q, {
                  key: r.key,
                  "is-header": m === 0 && t.isFirstColumnHeader,
                  "is-first": m === 0,
                  "is-last": m === t.columns.length - 1,
                  column: r,
                  "is-loading": $(r.key),
                  stretch: t.isStretched
                }, {
                  default: v(() => [
                    H(i.$slots, r.key, {
                      row: l,
                      item: n(r.key, l.columns)
                    }, () => [
                      t.withBooleanIcon ? (e(), s(u, { key: 0 }, [
                        n(r.key, l.columns) === !0 ? (e(), c(k(b), {
                          key: 0,
                          class: "ds-color-green",
                          category: "interface",
                          name: "checkmark-circle-fill"
                        })) : n(r.key, l.columns) === !1 ? (e(), c(k(b), {
                          key: 1,
                          class: "ds-color-grey-500",
                          category: "interface",
                          name: "cross-circle-fill"
                        })) : (e(), s("div", {
                          key: 2,
                          innerHTML: n(r.key, l.columns)
                        }, null, 8, G))
                      ], 64)) : (e(), s("div", {
                        key: 1,
                        innerHTML: n(r.key, l.columns)
                      }, null, 8, J))
                    ])
                  ]),
                  _: 2
                }, 1032, ["is-header", "is-first", "is-last", "column", "is-loading", "stretch"]))), 128))
              ]),
              _: 2
            }, 1032, ["stretch", "row-index"])
          ]),
          _: 2
        }, 1032, ["no-divider", "stretch"]))), 128))
      ], 10, _))
    ], 2));
  }
}), te = K;
export {
  te as default
};
